import { useSetAtom } from 'jotai';

import { useCurrentUser } from '@bizzabo/entities';

import ScheduledConfirmation from '../ScheduledConfirmation';
import ScheduleModal from '../ScheduleModal';
import { ScheduledMeeting } from '../../types';
import { useMeetings, View } from '../../MeetingsTool/MeetingsToolContext';
import useOtherUser from '../../hooks/useOtherUser';
import useTypeTracking from '../../../../analytics';
import { createChannelAtom } from '../../../messages';
interface MeetingScheduledModalProps {
    isOpen: boolean;
    meeting: ScheduledMeeting;
    closeModal: () => void;
}

const MeetingScheduledModal: React.FC<MeetingScheduledModalProps> = ({
    isOpen,
    meeting,
    closeModal,
}) => {
    const { eventId, setView } = useMeetings();
    const createChannelWith = useSetAtom(createChannelAtom);

    const { data: currentUser, isLoading: isLoadingCurrentUser } = useCurrentUser(eventId);
    const { data: otherUser, isLoading: isLoadingOtherUser } = useOtherUser(meeting);
    const { trackClickEvent, Track } = useTypeTracking({
        data: {
            description: {
                meeting_id: meeting.id,
            },
        },
    });

    const onCloseModal = () => {
        closeModal();
        trackClickEvent({
            subCategory: 'MEETING_CONFIRMATION_CLOSED',
        });
    };

    const sendMessage = () => {
        createChannelWith({ members: [otherUser.userProfileId], eventId });
        closeModal();
        setView(View.Manage);
        trackClickEvent({
            subCategory: 'REDIRECTED_TO_DIRECT_MESSAGING',
        });
    };

    const isLoading = isLoadingCurrentUser || isLoadingOtherUser;

    return (
        <Track>
            <ScheduleModal isOpen={isOpen} closeModal={onCloseModal}>
                {!isLoading && (
                    <ScheduledConfirmation
                        meeting={meeting}
                        currentUser={currentUser}
                        otherUser={otherUser}
                        sendMessage={sendMessage}
                    />
                )}
            </ScheduleModal>
        </Track>
    );
};

export default MeetingScheduledModal;
